import React from "react";
import { Spinner } from "react-activity";
import "react-activity/dist/library.css";

export default function CommonLoaderBlue({ color, sizehere }) {
  // Dynamically get root font-size (responsive)
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );

  return (
    <Spinner
      color={color ? color : "royalblue"}
      size={
        sizehere
          ? (sizehere / 10) * rootFontSize // e.g., 20 → 2rem → px
          : 3.2 * rootFontSize // default 3.2rem → px
      }
    />
  );
}
